// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RelatedFaculty_related-entities__o4zfQ {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.RelatedFaculty_related-entities--title__6XDBO {
  font-weight: bold;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/RelatedFaculty/RelatedFaculty.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EACE,iBAAA;EACA,eAAA;AAEJ","sourcesContent":[".related-entities {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  &--title {\n    font-weight: bold;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"related-entities": `RelatedFaculty_related-entities__o4zfQ`,
	"related-entities--title": `RelatedFaculty_related-entities--title__6XDBO`
};
export default ___CSS_LOADER_EXPORT___;
